import MessagesPanel from './MessagesPanel';

export default MessagesPanel;
